import React from "react"
import PropTypes from "prop-types"
import { useClipboard } from "@mantine/hooks"

// components
import { Button } from "@quorumus/plum"
import { Icon } from "@/components"
import Tooltip from "app/static/frontend/components/Tooltip"

export const PublicLinkAction = ({ isPublic, slug, type }) => {
    const clipboard = useClipboard({ timeout: 1500 })
    if (!isPublic) {
        return (
            <Tooltip label={`This ${type || "sheet"} does not have a shareable link`}>
                <div className="empty-text">Not shared</div>
            </Tooltip>
        )
    }

    return (
        <Tooltip label={`Copy this ${type || "sheet"}'s sharing link to your clipboard`}>
            <div className="action-button">
                <Button
                    leftSection={<Icon icon="link" iconFamily="fas" />}
                    variant="tertiary"
                    onClick={() =>
                        clipboard.copy(`${window.location.origin}/${type || "spreadsheet"}/external/${slug}/`)
                    }
                >
                    {clipboard.copied ? "Copied!" : "Copy Link"}
                </Button>
            </div>
        </Tooltip>
    )
}

PublicLinkAction.propTypes = {
    isPublic: PropTypes.bool.isRequired,
    slug: PropTypes.bool.isRequired,
    type: PropTypes.string,
}

export default PublicLinkAction
